import styled from "styled-components";
import { Box } from "components/Box";

export const WebGlWrapper = styled(Box)`
    height: 100%;
    width: 100%;
    
    body { 
        padding: 0; 
        margin: 0; 
    }
    #unity-container.unity-desktop { 
        width: 100%; 
        height: 100%;
        display: grid; 
        place-items: center;
    }
    #unity-container.unity-mobile {
        width: 100%;
        height: 100%;
    }
    #unity-canvas {
        background: rgb(205, 99, 255,0.1); 
        width: 100%;
        margin-top: 5px;
        margin-bottom: 5px;
        @media only screen and (max-width: 600px) {
            width: 100% !important;
            border: 7px solid rgb(205,99,255,0.1) !important;
            height: 80vh !important;
            margin-bottom: 0px;
        }
    }
    .unity-mobile #unity-canvas {
        width: 100%;
        height: 100%
    }
    #unity-loading-bar {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: none;
    }
    #loading-text {
        color: #fff;
        text-align: center;
        margin-bottom: 5px
    }
    // #unity-logo {
    //     width: 100%;
    //     height: 200px;
    //     background: url('./newAssets/WebGLScreen/CryptoTiles.png') no-repeat center;
    //     margin-bottom: 15px;
    //     background-size: cover
    // }
    #unity-progress-bar-empty {
        background: rgba(255,255,255,0.1);
        justify-content: flex-start;
        align-items: center;
        position: relative;
        padding: 0 5px;
        display: flex;
        height: 20px;
        min-width: 300px;
        max-width: 400px;
    }
    #unity-progress-bar-full {
        animation: load 3s normal forwards;
        box-shadow: 0 10px 40px -10px #fff;
        background: #fff;
        height: 10px;
        width: 0;
    }
    #unity-footer {
        position: relative;
    }
    .unity-mobile #unity-footer {
        display: none
    }
    #unity-webgl-logo {
        float:left;
        width: 204px;
        height: 38px;
        background: url('./newAassets/WebGLScreen/webgl-logo.png') no-repeat center
    }
    #unity-build-title {
        float: right;
        margin-right: 10px;
        line-height: 38px;
        font-family: arial;
        font-size: 18px;
        color: #fff;
    }
    #unity-mobile-warning {
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%);
        background: white;
        padding: 10px;
        display: none;
    }
`
export const GoogleAdsLeftBox = styled(Box)`
    background: rgb(205, 99, 255,0.1);
    // height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.mediaQueries.xs} {
        height: 10vh;
        width: 100%;
        margin-top: 0px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        height: 10vh;
        width: 250px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        height: 90vh;
        margin-top: 18px;
    }
`

export const GoogleAdsRightBox = styled(Box)`
   
    background: rgb(205, 99, 255,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.mediaQueries.xs} {
        height: 10vh;
        width: 100%;
        margin-top: 0px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        height: 10vh;
        width: 250px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        height: 90vh;
        margin-top: 18px;
    }
`
export const GameWrapper = styled(Box)`
    background-image: url("./newAssets/Hero/HeroBG-1.svg");
    background-repeat: no-repeat; 
    background-size: cover; 
    display: flex;
    ${({ theme }) => theme.mediaQueries.xs} {
        flex-direction: column;
        height: 100vh;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        flex-direction: row;
        justify-content: space-between;
    }
`